module.exports = __webpack_public_path__ + "static/media/fortlev-solar-usina-09.c8af6ca1.jpg";